import React, { Component } from 'react';
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, } from "@fortawesome/react-fontawesome";
export class PlaceItemInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            qtyDisplay: this.props.putawayQty
        }
        this.validateQuantityChange = this.validateQuantityChange.bind(this);
        this.validateTypeInput = this.validateTypeInput.bind(this);
    }

    componentDidMount() {
       this.props.focusInput('putawayBin');
    }


    validateQuantityChange(value, maxQty) {
        console.log("VALUE", value, "MAX QTY", maxQty);
        let currentQty = this.state.qtyDisplay ? parseInt(this.state.qtyDisplay) : 0;
        const newQty = currentQty + value;
        console.log("NEW QTY", newQty, "MAX QTY", maxQty);
        if (newQty < 0 || newQty > maxQty) {
            if (newQty > maxQty) {
                alert("You do not need any more of this item. You only need " + maxQty);
                document.getElementById('qty-edit-input').focus();
            }
            return;
        }
        this.props.updateQuantity(newQty)
        this.setState({
            qtyDisplay: newQty
        })
        document.getElementById('qty-edit-input').focus();
    }

    validateTypeInput(e, maxQty) {
        let newQty = e.target.value;
        if (!newQty) {
            this.setState({
                qtyDisplay: ''
            });
            document.getElementById('qty-edit-input').focus();
            return;
        }
        else {
            newQty = parseInt(newQty);
        }
        console.log("NEW QTY", newQty, "MAX QTY", maxQty);
        if (newQty > maxQty) {
            alert("You must enter a number between 0 and " + maxQty);
            document.getElementById('qty-edit-input').focus();
            return;
        }
        const qtyDifference = newQty - this.state.qtyDisplay;
        this.validateQuantityChange(qtyDifference, maxQty);
    }


    render() {
        console.log("MY PROPS", this.props);
        const putawayItem = this.props.putawayItem;
        console.log("PUTAWAY ITEM 2", putawayItem);
        const maxQty = putawayItem.qty;
        return (
            <div>
                <div className="bin-qty-edit">
                    <h3>{putawayItem.displayname}</h3>
                    <b>Avail: {maxQty}</b><br />
                    <div class="number">
                        <FontAwesomeIcon className="imageIcon" onClick={() => this.validateQuantityChange(-1, maxQty)} size="lg" icon={faMinus} />
                        <input id="qty-edit-input" onBlur={() => { this.props.focusInput('putawayBin'); }} onChange={(e) => { this.validateTypeInput(e, maxQty) }} type="number" value={this.state.qtyDisplay} min="0" max={maxQty} />
                        <FontAwesomeIcon className="imageIcon" onClick={() => this.validateQuantityChange(1, maxQty)} size="lg" icon={faPlus} />
                    </div>
                </div>
                <div className="scan-field">
                    <br/>
                    <h3>Scan a Bin</h3>
                    <input type="text" id="putawayBin" value={this.props.putawayBin} onChange={(e) => { this.props.updateInputValue(e) }} /
                    ><br /><br />
                </div>
                {
                    putawayItem.perishableItem &&
                    <div>
                            <br />
                            <div className="perishable-item-info">
                                <b>Perishable Item - Check Dates</b>
                            </div>
                            <br />

                    </div>
                }
                {
                    putawayItem?.binInfo?.length > 0 &&
                    <div className="scrollable-list">
                        <table className="table table-striped" aria-labelledby="tabelLabel">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    putawayItem.binInfo.map(bin =>
                                        <tr key={bin.binNumber}>
                                            <td>{bin.binNumber}</td>
                                            <td>{bin.qty}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                            </table>
                    </div>
                }
                
            </div>
        );
    }
}